import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createStore, applyMiddleware,  AnyAction } from 'redux';
import { Provider } from 'react-redux';

import "react-datepicker/dist/react-datepicker.css";

import RefreshTokenMiddleware from './middleware/RefreshTokenMiddleware';


const reducer = (state = 0, action: AnyAction) => {
  switch (action.type) {
    case "INCREMENT":
      return state + action.payload;
    case "DECREMENT":
      return state - action.payload;
    default:
      return state;
  }
};

const store = createStore(reducer, 
                          applyMiddleware(RefreshTokenMiddleware)
                         );


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
